import React from 'react';
import PropTypes from 'prop-types';
import SortingIcon from "../../table-common/SortingIcon";
import ItemStatus from "../../table-common/ItemStatus";

const TableHeader = ({sortingBy, sortReversed, changeSort, selectedTrain}) => {
    return (
      <thead>
        <tr>
          <th onClick={() => changeSort('car_id')}>
                Car Number
                <SortingIcon
                  visible={sortingBy === 'car_id'} reversed={sortReversed}
                />
            </th>
            {!selectedTrain ? 
            <th onClick={() => changeSort('trainLineNumber')}>
                Train No.
                <SortingIcon
                  visible={sortingBy === 'trainLineNumber'} reversed={sortReversed}
                />
            </th> : <th></th>}

            <th onClick={() => changeSort('diagnosticStatus')}>
                Diagnostics Status 
                <SortingIcon
                  visible={sortingBy === 'diagnosticStatus'} reversed={sortReversed}
                />
            </th>
            <th onClick={() => changeSort('bearingMaintenanceStatus')}>
                Bearing Maintenance Status
                <SortingIcon
                  visible={sortingBy === 'bearingMaintenanceStatus'} reversed={sortReversed}
                />
            </th>
            <th onClick={() => changeSort('inService')}>
                In Service
                <SortingIcon
                  visible={sortingBy === 'inService'} reversed={sortReversed }
                />
            </th>
            <th onClick={() => changeSort('specialCar')}>
                Special Car
                <SortingIcon
                  visible={sortingBy === 'specialCar'} reversed={sortReversed}
                />
            </th>
        </tr>
      </thead>
    )
}

TableHeader.propTypes = {
    sortingBy: PropTypes.string,
    sortReversed: PropTypes.bool,
    changeSort: PropTypes.func,
    selectedTrain: PropTypes.bool,
}

const TableRow = ({element, rowSelected, selectedTrain}) => {
    return (
        <tr onClick={() => rowSelected(element)}>
          <td>{element.car_id}</td>
          {!selectedTrain ? <td>{element.trainLineNumber || '-'}</td> : <td></td>}
          <td>{<ItemStatus status={element.diagnosticStatus}/>}</td>
          <td>{<ItemStatus status={element.bearingMaintenanceStatus}/>}</td>
          <td>{element.inService ? 'YES' : 'NO'}</td>
          <td>{element.specialCar || '-'}</td>
        </tr>
    )
};
TableRow.propTypes = {
    element: PropTypes.object,
    rowSelected: PropTypes.func,
    selectedTrain: PropTypes.bool
}

const CarTable = ({data, sorting, rowSelected, selectedTrain}) => {
    let tableContent;
    if (data.length) {
        tableContent = data.map((element, index) =>
            (<TableRow
                key={`table-row-${index}`}
                element={element}
                rowSelected={rowSelected}
                selectedTrain={selectedTrain}
                />
            ));
    }
    return (
        <div className="car-table">
            <table aria-label="Car status">
                <TableHeader
                    sortingBy={sorting.sortingBy}
                    sortReversed={sorting.sortReversed}
                    changeSort={sorting.changeSort}
                    selectedTrain={selectedTrain}
                />
                <tbody>{tableContent}</tbody>
            </table>
        </div>
    );
};

CarTable.propTypes = {
    data: PropTypes.array,
    sorting: PropTypes.object,
    rowSelected: PropTypes.func,
};

export default CarTable;